export default (props, vars) => !props?.['multiline'];
